export default "__VITE_ASSET__5HgPZ7$2__"